import styled from 'styled-components';
import { detailsBackground, textGrey } from '../../config/colors';
import { ReactComponent as WeightIconSvg } from '../../resources/weight.svg';
import { ReactComponent as DimenssionsIconSvg } from '../../resources/dimensions.svg';

export const PhysicalWrapper = styled.div`
  background-color: ${detailsBackground};
  padding-left: 35px;
  padding-top: 10px;
  padding-bottom: 5px;
  padding: 10px 150px 5px 35px;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 65px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const WeightIcon = styled(WeightIconSvg)`
  width: 22px;
  height: 22px;
  margin-inline: 10px;
`;

export const DimensionsIcon = styled(DimenssionsIconSvg)`
  width: 22px;
  height: 22px;
  margin-top: 3px;
  transform: rotate(180deg);
  margin-left: 60px;
  margin-right: 10px;
`;

export const DimensionsInput = styled.input`
  font-size: 1.25rem;
  font-weight: 500;
  color: ${textGrey};
  width: 100px;
  padding: 10px 15px;
  text-align: center;
  border: none;
`;

export const DimensionsText = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  color: ${textGrey};
  margin-inline: 15px;
`;

export const DimensionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MeasurementIndicator = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  color: ${textGrey};
`;
